export const parseDateIntoMillisecond = (variable) => {
  let isCorrect = new Date(variable);

  console.log("isCorrect", isCorrect);

  if (isCorrect && variable) {
    return Date.parse(variable);
  } else {
    return null;
  }
};
